import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppStore } from '../../app.store';

let activeRequests = 0;

export const loadingInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const appStore = inject(AppStore);

  activeRequests++;

  if (activeRequests === 1) {
    appStore.setLoading(true);
  }

  return next(request).pipe(
    finalize(() => {
      activeRequests--;

      if (activeRequests === 0) {
        appStore.setLoading(false);
      }
    })
  );
};
